import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { InfluencerService } from '../../../services/influencer/influencer.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { InfluencerCampaignActivity, InfluencerCampaignStatus, InfluencerCampaignPost } from '../../../../models/influencer-campaign';
import { Kpi } from '../../../../models/common';
import { CommonConstant, CampaignInfluencerStatus } from '../../../app.constants';
import { AuthService } from '../../../core/auth.service';
import { User } from '../../../../models/user';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../../services/modal/modal.service';
import { PlaceholderVisibilityService } from '../../../services/placeholder-visibility/placeholder-visibility.service';
import { EventTrackerService, UserActionType, Page, ActivePages } from '../../../services/event-tracker/event-tracker.service';
import { CacheService } from '../../../services/cache/cache.service';
import { UserService } from '../../../services/user.service';
import {Observable} from 'rxjs/Observable';
import {EventFilter, EventFilterType, EventType} from '../../../../models/user-notification';
import { Location } from '@angular/common';

enum InfluencerCampaignParam {
  removedCampaign = 0,
}

@Component({
  selector: 'influencer-campaign-activity',
  templateUrl: './influencer-campaign-activity.component.html',
  styleUrls: ['./influencer-campaign-activity.component.scss']
})
export class InfluencerCampaignActivityComponent implements OnInit {
  @ViewChild('AlertUpdateInfluencerCampaignStatusSuccess')
  public alertUpdateInfluencerCampaignStatusSuccess: AchooPopupComponent;
  @Input() influencerId: number;
  @Input() campaignInfluencerId: number;
  @Input() fromPath: string;
  @Input() isReadOnly: boolean;
  @Input() campaignId: number;
  @Output() selectPostToDeleteFromCampaign: EventEmitter<any> = new EventEmitter();
  @Output() selectedInfluencerCampaignChanged: EventEmitter<InfluencerCampaignActivity> = new EventEmitter<InfluencerCampaignActivity>();

  private user: User;
  public campaignList: any[];
  public selectedCampaignInfluencerId: number;
  public selectedCampaign: InfluencerCampaignActivity;
  public campaignInfluencerKPI: Kpi | null;
  private slider: InfluencerCampaignStatus[];
  public campaignSilder: InfluencerCampaignStatus[];
  public campaignPosts: InfluencerCampaignPost[];

  public previousStt: string;
  public currentStt: string;


  constructor(
    private influencerService: InfluencerService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: ModalService,
    private placeholderService: PlaceholderVisibilityService,
    private eventTracker: EventTrackerService,
    public cacheService: CacheService,
    private auth: AuthService,
    private location: Location,
    private userService: UserService) {
    this.selectedCampaign = new InfluencerCampaignActivity();
    this.user = this.auth.getUser();
    this.slider = [
      {i: 0, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name, selected: false},
      {i: 1, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.name, selected: false},
      {i: 2, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name, selected: false},
      {i: 3, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.PUBLISHED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.PUBLISHED.name, selected: false}
    ];
  }

  ngOnInit() {
    this.initialize();
    // segment track event
    this.eventTracker.trackUserAction(UserActionType.VIEW, Page.INFLUENCER_CAMPAIGNS, {
      id: this.influencerService.influencerDetails.id,
      name: this.influencerService.influencerDetails.name,
      type: Page.INFLUENCER
    }, undefined, undefined, {
      type: ActivePages.INFLUENCER_CAMPAIGNS,
      name: this.influencerService.influencerDetails.name,
      id: this.influencerService.influencerDetails.id
    });
  }

  public initialize() {
    if (this.campaignInfluencerId && this.campaignInfluencerId === InfluencerCampaignParam.removedCampaign) {
      this.getCampaignListOfInfluencer();
    }
    // in case campaignInfluencerId as query param
    if (this.campaignInfluencerId && this.campaignInfluencerId !== InfluencerCampaignParam.removedCampaign
      && Number(this.campaignInfluencerId) !== this.selectedCampaignInfluencerId) {
      this.getCampaignListOfInfluencer(Number(this.campaignInfluencerId));
    }
    // in case no campaignInfluencerId as query param
    if (this.campaignInfluencerId === undefined) {
      this.getCampaignListOfInfluencer();
    }
  }

  public updateRouterQueryParams() {
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['campaignInfluencerId'] = this.selectedCampaign.campaignInfluencerId;
    queryParams['selectedCampaign'] = this.selectedCampaign.campaignId;
    queryParams['activeAccount'] = this.userService.getCompanyId();
    const url = this.router.createUrlTree(['influencer', this.influencerId, 'campaign'],
      { queryParams: queryParams }).toString();
    this.selectedInfluencerCampaignChanged.emit(this.selectedCampaign);
    this.location.go(url);
  }

  private updateInfluencerCampaignStatus(status) {
    const data = {
      accessLevel: this.user.type,
      id: this.selectedCampaign.campaignInfluencerId,
      status: status,
    };
    this.influencerService.updateInfluencerCampaignStatus(data).subscribe((res: any) => {
      this.selectedCampaign.status = status;
      this.modalService.open(this.alertUpdateInfluencerCampaignStatusSuccess, undefined, true);
    });
  }

  private updateSlider(status) {
    this.campaignSilder = this.slider.slice(0); // clone new slider
    this.campaignSilder.forEach(item => {
      if (item.name === status) {
        item.selected = true;
      } else {
        item.selected = false;
      }
    });
  }

  public clearCachedData(campaignInfluencerId) {
    this.cacheService.clear(`campaign_influencer_list_${campaignInfluencerId}`);
    this.cacheService.clear(`campaign_influencer_${campaignInfluencerId}`);
  }

  public clearSelectionAndReset() {
    this.campaignInfluencerId = undefined;
    this.cacheService.clear(`campaign_influencer_list_${this.influencerId}_${this.userService.getCompanyId()}`);
    this.initialize();
  }

  /**
   * get list influencer belonged to a campaign. Get data from cached memory
   * If not existed. Fetch data from server
   * @param selectedCampaignInfluencerId
   */
  private getCampaignListOfInfluencer(selectedCampaignInfluencerId?) {
    // get campaign list of influencer
    const params = {
      influencer_id: this.influencerId,
      page: CommonConstant.START_PAGE_INDEX,
      page_size: 50,
      company_id: this.userService.getCompanyId()
    };
    const cachingKey = `campaign_influencer_list_${this.influencerId}_${this.userService.getCompanyId()}`;
    this.cacheService.get(cachingKey, this.influencerService.getCampaignListOfInfluencer(params))
      .subscribe((res: any) => {
        this.campaignList = res.filter(item => item.companyId === this.userService.getCompanyId());
        if (this.campaignList.length > 0) {
          const preSelectedCampaign = this.campaignList.find(item => item.campaignInfluencerId === selectedCampaignInfluencerId);
          if (preSelectedCampaign) {
            this.selectedCampaignInfluencerId = selectedCampaignInfluencerId;
            this.selectedCampaign = preSelectedCampaign;
          } else {
            this.selectedCampaign = {...this.campaignList[0]};
            this.selectedCampaignInfluencerId = this.campaignList[0].id;
          }
          this.getCampaignInfluencerData(this.selectedCampaign.campaignInfluencerId);
        } else {
          this.selectedCampaign = new InfluencerCampaignActivity();
          this.selectedCampaignInfluencerId = undefined;
          this.campaignInfluencerKPI = undefined;
          this.campaignPosts = undefined;
        }
        this.updateRouterQueryParams();
    });
  }

  private getCampaignInfluencerData(campaignInfluencerId: number) {
    this.placeholderService.show(CommonConstant.INFLUENCER_CAMPAIGN_DETAILS_HOLDER);
    const campaignInfluencerSubscriptions = Observable.forkJoin([
      this.cacheService.get(
        `campaign_influencer_${campaignInfluencerId}`,
        this.influencerService.getCampaignInfluencerData(campaignInfluencerId)
      ),
      this.userService.getNewEventFromLastTime(
        EventType.NEW_CAMPAIGN_POST,
        this.userService.getCompanyId(),
        this.userService.lastViewedCampaignTime(),
        new EventFilter(EventFilterType.URL_HASH, campaignInfluencerId)
      )
    ]);

    campaignInfluencerSubscriptions.subscribe(([res, newEvent]) => {
        // parse KPI
        const postKpi = new Kpi();
        postKpi.engagement.value = res.globalKpi.engagement;
        postKpi.impact.value = res.globalKpi.impact * 100;
        postKpi.impressions.value = res.globalKpi.impression;
        postKpi.reach.value = res.globalKpi.reach;
        postKpi.post.value = res.globalKpi.post;
        this.campaignInfluencerKPI = postKpi;
        // parse post list
        const postList = res.postList.map(post => ({
          imageUrl: post.image,
          title: post.page_title,
          date: post.date,
          relativePath: post.relativePath,
          fullUrl: post.full_url,
          platformBlogs: post.platformBlogs,
          platformInstagram: post.platformInstagram,
          platformYoutube: post.platformYoutube,
          platformSnapchat: post.platformSnapchat,
          platformTwitter: post.platformTwitter,
          platformPinterest: post.platformPinterest,
          platformFacebook: post.platformFacebook,
          platformTiktok: post.platformTiktok,
          reach: post.reach.value,
          engagement: post.engagement.value,
          impressions: post.impression && post.impression.value > 0 ? post.impression.value : post.reach.value,
          impact: post.impact.value,
          urlHash: post.urlHash,
          channelId: post.channelId,
          isNew: newEvent && newEvent.events.filter(evt => evt.key === post.urlHash).length > 0
        }));
        this.campaignPosts = postList;
        // parse campaign influencer details
        this.selectedCampaign.description = res.campaign.brief;
        this.selectedCampaign.status = res.campaign.status;
        this.updateSlider(this.selectedCampaign.status);
        this.placeholderService.hide(CommonConstant.INFLUENCER_CAMPAIGN_DETAILS_HOLDER);
      });
  }

  public onSelectCampaign(campaign) {
    this.selectedCampaign = campaign;
    if (this.selectedCampaign === undefined) { // in case of un-selecting any campaign
      this.selectedCampaign = new InfluencerCampaignActivity();
      this.selectedCampaignInfluencerId = undefined;
      this.campaignInfluencerKPI = undefined;
      this.campaignPosts = [];
      this.updateRouterQueryParams();
      return;
    }
    this.getCampaignInfluencerData(this.selectedCampaign.campaignInfluencerId);
    this.updateRouterQueryParams();
  }

  public changeStatus(event) {
    this.closeModalDialog();
    this.previousStt = this.capitalizeStatusText(this.selectedCampaign.status);
    this.currentStt = this.capitalizeStatusText(event.name);
    this.updateInfluencerCampaignStatus(event.name);
  }

  private capitalizeStatusText(txt) {
    return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
  }

  public closeModalDialog() {
    this.modalService.close();
  }

  public onSelectPost(evt) {
    const postToDelete = this.campaignPosts.filter(p => p.selected).map((post) => ({
      urlHash: post.urlHash,
      channelId: post.channelId
    }));
    this.selectPostToDeleteFromCampaign.emit({
      campaignId: this.selectedCampaign.campaignId,
      posts: postToDelete
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-campaign-activity/influencer-campaign-activity.component.ts